import Vue from "vue"
import Router from "vue-router"
import { Toast } from "vant"
import { isLoggedIn, saveLoginUserId } from "@/utils/auth"
import { initCurrentStaffProfile } from "@/store/currentStaff"
import { API_BASE_URL } from "@/config"

Vue.use(Router)

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: "/", redirect: "/customer-track" },
    {
      path: "/customer-track",
      name: "CustomerTrack",
      component: () => import("@/views/CustomerTrack.vue")
    },
    {
      path: "/course-consumed",
      name: "CourseConsumed",
      component: () => import("@/views/CourseConsumed.vue")
    },
    {
      path: "/inventoryApproval",
      redirect: "/material-approval"
    },
    {
      path: "/material-approval",
      name: "MaterialApproval",
      component: () => import("@/views/MaterialApproval.vue")
    },
    {
      path: "/expense-approval",
      name: "ExpenseApproval",
      component: () => import("@/views/ExpenseApproval.vue")
    },
    {
      path: "/income-manage",
      name: "IncomeManage",
      component: () => import("@/views/IncomeManage.vue")
    },
    {
      path: "/refund-approval",
      name: "RefundApproval",
      component: () => import("@/views/RefundApproval.vue")
    },
    {
      path: "/transfer-center-approval",
      name: "TransferCenterApproval",
      component: () => import("@/views/TransferCenterApproval.vue")
    },
    {
      path: "/project-manage",
      name: "ProjectManage",
      component: () => import("@/views/ProjectManage.vue")
    },
    {
      path: "/reimApproval",
      redirect: "/expense-approval"
    }
  ]
})

let loginPending = false

function pickCallbackUserId(to) {
  const q = to?.query || {}
  const direct = q.userId || q.userid || q.userID
  if (direct) return String(direct).trim()

  const full = String(to?.fullPath || "")
  const idx = full.indexOf("?")
  if (idx >= 0) {
    const search = full.slice(idx + 1)
    const p = new URLSearchParams(search)
    const fromFullPath = p.get("userId") || p.get("userid") || p.get("userID")
    if (fromFullPath) return String(fromFullPath).trim()
  }

  const fromWindow =
    new URLSearchParams(window.location.search).get("userId") ||
    new URLSearchParams(window.location.search).get("userid") ||
    new URLSearchParams(window.location.search).get("userID")
  return fromWindow ? String(fromWindow).trim() : ""
}

router.beforeEach(async (to, from, next) => {
  const userId = pickCallbackUserId(to)

  if (userId) {
    saveLoginUserId(userId)
    // 回调参数通常挂在 location.search（hash 路由下不会随 next() 自动清除），
    // 不先清掉会在守卫中反复命中 userId 分支，导致无限跳转。
    if (window.location.search) {
      const cleanUrl = `${window.location.origin}${window.location.pathname}${window.location.hash || ""}`
      window.history.replaceState({}, "", cleanUrl)
    }
    try {
      await initCurrentStaffProfile()
    } catch (_) {
      /* 员工信息拉取失败不阻断进入页面 */
    }
    next({ path: to.path && to.path !== "/" ? to.path : "/customer-track", replace: true })
    return
  }

  if (isLoggedIn()) {
    try {
      await initCurrentStaffProfile()
    } catch (_) {
      /* ignore */
    }
    next()
    return
  }

  if (loginPending) return
  loginPending = true
  Toast.loading({ message: "跳转企业微信登录...", forbidClick: true, duration: 0 })
  try {
    const base = String(API_BASE_URL || "").replace(/\/+$/, "")
    const redirectUrl = `${base}/mgm-crm-api/wechat/login`
    Toast.clear()
    window.location.replace(redirectUrl)
  } catch (e) {
    Toast.clear()
    next(false)
  } finally {
    loginPending = false
  }
})

export default router

